import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';

function ContactsConfirmationRedirectButton({
  additionalUnitQuantity,
  offerId,
  activeTerm,
  className,
  style = {},
  seleniumId,
  ownsProduct,
  onClick = () => {},
  trackingSource,
  use,
  children,
  upgradeData
}) {
  const handleClick = () => {
    onClick({
      additionalUnitQuantity,
      offerId,
      activeTerm,
      ownsProduct,
      trackingSource
    });
  };

  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: BILLING,
    modalType: REQUEST_SKU,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-selenium-id": `${trackingSource}-${seleniumId}-confirm-contacts-button`,
      className: className,
      style: style,
      use: use,
      "data-reagan-primary-cta": true,
      onClick: handleClick,
      target: "_blank",
      truncate: true,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.pricingCtas.${ownsProduct ? 'buyAdditionalContacts' : 'buyNow'}`
      })
    })
  });
}

ContactsConfirmationRedirectButton.propTypes = {
  additionalUnitQuantity: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  seleniumId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ownsProduct: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  trackingSource: PropTypes.string.isRequired,
  use: PropTypes.string.isRequired,
  activeTerm: PropTypes.string,
  offerId: PropTypes.number,
  children: PropTypes.node,
  upgradeData: PropTypes.object.isRequired
};
export default ContactsConfirmationRedirectButton;